var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Button } from "@animech/ui";
import { useTranslation } from "react-i18next";
import * as Styled from "./newsflash.style";
import { ReleaseNotes } from "ui/components/elements/release-notes";
import { ReleaseNotesContainer } from "ui/components/elements/release-notes/release-notes.style";
export var NewsflashModal = function (props) {
    var releaseNotes = props.releaseNotes;
    var t = useTranslation().t;
    var closeModal = function () {
        localStorage.setItem("lastViewedNewsflashId", releaseNotes[0].id);
        props.onShouldClose && props.onShouldClose();
    };
    return (_jsxs(Styled.NewsflashRoot, __assign({}, props, { title: t("newsflash.title"), color: "inverted", onShouldClose: closeModal, children: [_jsx(ReleaseNotesContainer, { children: _jsx(ReleaseNotes, { releaseNotes: releaseNotes }) }), _jsx(Styled.Footer, { children: _jsx(Button, { onClick: function () { return closeModal(); }, children: t("newsflash.button_text") }) })] })));
};
